import { useEffect } from "react";
import VoiceReminderAlert from "./VoiceReminderAlert";
import {
  startReminderWatcher,
  stopReminderWatcher,
} from "../utils/reminderNotifier";

/** 全站提醒调度：到点后弹窗 + 语音播报 */
export default function ReminderGlobalWatcher() {
  useEffect(() => {
    startReminderWatcher();
    return () => stopReminderWatcher();
  }, []);

  return <VoiceReminderAlert />;
}
